var Footer = /** @class */ (function () {
    function Footer() {
        this.footer = document.querySelector('.footer');
        this.menuItems = this.footer.querySelectorAll('.menu-item');
        this.addEventListeners();
    }
    Footer.prototype.addEventListeners = function () {
        this.menuItems.forEach(function (menuItem) {
            menuItem.addEventListener('click', function (event) {
                var currentTarget = event.currentTarget;
                // If menu link has # in href - scroll to anchor
                if (currentTarget.querySelector('a').getAttribute('href').indexOf('#') !== -1) {
                    // if href page is current page - prevent default
                    if (currentTarget.querySelector('a').getAttribute('href').split('#')[0] === window.location.href.split('#')[0]) {
                        event.preventDefault();
                    }
                    var anchorId = currentTarget.querySelector('a').getAttribute('href').split('#')[1];
                    var anchor = document.getElementById(anchorId);
                    if (anchor) {
                        anchor.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            });
        });
    };
    return Footer;
}());
export default Footer;
